const _ = require("lodash");
const {findOptionalArgument, findArguments} = require("../util/ParserHelpers");
const {symbolColors, symbolInfo} = require("../util/RenderHelpers");
const DrawImageUtil = require("../../util/DrawImageUtil");
const CommandUtil = require("../util/CommandUtil");
const colors = require("../../util/ColorUtil").getDiagramColors();

const symbolParser = function(ps) {
	const optArg = findOptionalArgument(ps);
	const args = findArguments(ps, 1);
	if (!args) {
		return false;
	}
	const mappedKeys = _.filter(
		_.map(symbolInfo, symbol => symbol.mappedKey),
		key => key !== null
	);
	const input = args[0].getRest().toLowerCase();

	if (!symbolInfo[input] && !_.includes(mappedKeys, input)) {
		const symbolNamesWithKeys = [];
		_.each(symbolInfo, function(value, key) {
			symbolNamesWithKeys.push(
				key + (value.mappedKey !== null ? " (" + value.mappedKey + ")" : "")
			);
		});

		ps.pushError(
			input +
				" is not a valid symbol nickname. Possible names are the following: " +
				symbolNamesWithKeys.join(", ") +
				"."
		);
		return false;
	}

	const name =
		input.length === 1
			? _.findKey(symbolInfo, x => x.mappedKey === input)
			: input;

	return [
		{
			type: "symbol",
			name: name,
			color: optArg.text,
		},
	];
};

const symbolNode = {
	draw(rc, x, y, node, measure) {
		const context = rc.context;
		const {width, top, bottom} = measure;
		const color = colors[node.color] || node.color;

		const img = DrawImageUtil.getPremadeColorImage(
			global.BASE_URL +
				"assets/images/problem-art/symbols/" +
				symbolInfo[node.name].img,
			color,
			symbolColors
		);

		context.drawImage(img, x, y - top, width, top + bottom);
	},
	measure(rc, fontInfo, props, node) {
		const size = fontInfo.size * 1.1;
		return {
			width: size,
			top: size / 2,
			bottom: size / 2,
			fontInfo,
		};
	},
	readAloud: function(node, context) {
		const symbolData = symbolInfo;
		const symbol = node.name;
		if (symbolData[symbol]) {
			return symbolData[symbol].name;
		} else {
			return CommandUtil.logReadAloudErrorAndGetReturnValue(
				`no symbol or no symbol name for symbol ${symbol}`,
				"E_READ_ALOUD_SYMBOL_ERROR",
				node
			);
		}
	},
};

module.exports = {
	parsers: {
		mathCommands: {
			symbol: symbolParser,
		},
	},
	nodes: {
		symbol: symbolNode,
	},
};
